"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExercisesApi = exports.ExercisesApiFactory = exports.ExercisesApiFp = exports.ExercisesApiAxiosParamCreator = exports.LanguageCode = exports.ExerciseType = exports.ExerciseDescriptorDtoV1TypeEnum = exports.ExerciseDescriptorDtoV1LanguageCodeEnum = void 0;
const axios_1 = require("axios");
const common_1 = require("./common");
const base_1 = require("./base");
exports.ExerciseDescriptorDtoV1LanguageCodeEnum = {
    ar_idn: 'ar-idn',
    en: 'en',
    nl: 'nl',
    zh: 'zh',
    fr: 'fr',
    de: 'de',
    es: 'es'
};
exports.ExerciseDescriptorDtoV1TypeEnum = {
    choice: 'choice',
    pronunciation: 'pronunciation',
    word_cloud: 'word-cloud'
};
exports.ExerciseType = {
    choice: 'choice',
    pronunciation: 'pronunciation',
    word_cloud: 'word-cloud'
};
exports.LanguageCode = {
    ar_idn: 'ar-idn',
    en: 'en',
    nl: 'nl',
    zh: 'zh',
    fr: 'fr',
    de: 'de',
    es: 'es'
};
const ExercisesApiAxiosParamCreator = function (configuration) {
    return {
        createExercise: async (createExerciseDtoV1, options = {}) => {
            (0, common_1.assertParamExists)('createExercise', 'createExerciseDtoV1', createExerciseDtoV1);
            const localVarPath = `/v1/exercises`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createExerciseDtoV1, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteExercise: async (id, options = {}) => {
            (0, common_1.assertParamExists)('deleteExercise', 'id', id);
            const localVarPath = `/v1/exercises/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getExercise: async (id, options = {}) => {
            (0, common_1.assertParamExists)('getExercise', 'id', id);
            const localVarPath = `/v1/exercises/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getExerciseList: async (custom, exerciseType, languageCode, options = {}) => {
            const localVarPath = `/v1/exercises`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (custom !== undefined) {
                localVarQueryParameter['custom'] = custom;
            }
            if (exerciseType !== undefined) {
                localVarQueryParameter['exerciseType'] = exerciseType;
            }
            if (languageCode !== undefined) {
                localVarQueryParameter['languageCode'] = languageCode;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        replaceExercise: async (id, replaceExerciseDtoV1, options = {}) => {
            (0, common_1.assertParamExists)('replaceExercise', 'id', id);
            (0, common_1.assertParamExists)('replaceExercise', 'replaceExerciseDtoV1', replaceExerciseDtoV1);
            const localVarPath = `/v1/exercises/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(replaceExerciseDtoV1, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ExercisesApiAxiosParamCreator = ExercisesApiAxiosParamCreator;
const ExercisesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ExercisesApiAxiosParamCreator)(configuration);
    return {
        async createExercise(createExerciseDtoV1, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExercise(createExerciseDtoV1, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async deleteExercise(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteExercise(id, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getExercise(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExercise(id, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getExerciseList(custom, exerciseType, languageCode, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExerciseList(custom, exerciseType, languageCode, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async replaceExercise(id, replaceExerciseDtoV1, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceExercise(id, replaceExerciseDtoV1, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.ExercisesApiFp = ExercisesApiFp;
const ExercisesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ExercisesApiFp)(configuration);
    return {
        createExercise(createExerciseDtoV1, options) {
            return localVarFp.createExercise(createExerciseDtoV1, options).then((request) => request(axios, basePath));
        },
        deleteExercise(id, options) {
            return localVarFp.deleteExercise(id, options).then((request) => request(axios, basePath));
        },
        getExercise(id, options) {
            return localVarFp.getExercise(id, options).then((request) => request(axios, basePath));
        },
        getExerciseList(custom, exerciseType, languageCode, options) {
            return localVarFp.getExerciseList(custom, exerciseType, languageCode, options).then((request) => request(axios, basePath));
        },
        replaceExercise(id, replaceExerciseDtoV1, options) {
            return localVarFp.replaceExercise(id, replaceExerciseDtoV1, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ExercisesApiFactory = ExercisesApiFactory;
class ExercisesApi extends base_1.BaseAPI {
    createExercise(createExerciseDtoV1, options) {
        return (0, exports.ExercisesApiFp)(this.configuration).createExercise(createExerciseDtoV1, options).then((request) => request(this.axios, this.basePath));
    }
    deleteExercise(id, options) {
        return (0, exports.ExercisesApiFp)(this.configuration).deleteExercise(id, options).then((request) => request(this.axios, this.basePath));
    }
    getExercise(id, options) {
        return (0, exports.ExercisesApiFp)(this.configuration).getExercise(id, options).then((request) => request(this.axios, this.basePath));
    }
    getExerciseList(custom, exerciseType, languageCode, options) {
        return (0, exports.ExercisesApiFp)(this.configuration).getExerciseList(custom, exerciseType, languageCode, options).then((request) => request(this.axios, this.basePath));
    }
    replaceExercise(id, replaceExerciseDtoV1, options) {
        return (0, exports.ExercisesApiFp)(this.configuration).replaceExercise(id, replaceExerciseDtoV1, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ExercisesApi = ExercisesApi;
//# sourceMappingURL=api.js.map